// extracted by mini-css-extract-plugin
export default {"appContainer":"styles_appContainer__V15Di","isRtl":"styles_isRtl__ZXy1h","fullAppContainer":"styles_fullAppContainer__UK3-x","noProjectSelector":"styles_noProjectSelector__3wnp9"};